// utils/auth.js
import Cookies from "js-cookie";

const TOKEN_NAME = "icontec_token";

/**
 * Guarda el token en cookies usando expiresAt (fecha ISO) de la API
 * @param {string} token - JWT recibido del API
 * @param {string} expiresAtISO - Fecha de expiración en formato ISO
 */
export const setToken = (token, expiresAtISO) => {
  if (!token) return; // si no hay token, no hacemos nada

  let expiresDays;
  if (expiresAtISO) {
    const expiresDate = new Date(expiresAtISO);
    const now = new Date();
    expiresDays = (expiresDate - now) / (1000 * 60 * 60 * 24); // ms → días
    if (expiresDays < 0) expiresDays = 1; // mínimo 1 día
  }

  Cookies.set(TOKEN_NAME, token, { expires: expiresDays });
};

/**
 * Obtiene el token desde cookies
 * @returns {string | undefined}
 */
export const getToken = () => Cookies.get(TOKEN_NAME);

/**
 * Elimina el token de cookies
 */
export const clearToken = () => Cookies.remove(TOKEN_NAME);

/**
 * Verifica si existe un token válido
 * @returns {boolean}
 */
export const isTokenValid = () => !!getToken();
